const SELECT_ROBOT = 'scratch-gui/robot/SELECT_ROBOT';

const initialState = {
    cdid: ''
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SELECT_ROBOT:
        return Object.assign({}, state, {
            cdid: action.cdid
        });
    default:
        return state;
    }
};

const selectRobot = function (robot) {
    return {
        type: SELECT_ROBOT,
        cdid: robot
    };
};

const initRobot = function (currentState, robot) {
    return Object.assign(
        {},
        currentState,
        {
            cdid: robot
        }
    );
};
export {
    reducer as default,
    initialState as robotInitialState,
    initRobot,
    selectRobot
};
